'use strict';

angular.module('shiftTraderApp')
    .controller('OrganizationMessagesListCtrl', function ($scope, $location, $state, flash, Users, OrganizationMessages, TimeService, allPositions, UserPermissionsService, me, org, currentOrgMessages) {
      $scope.me = me;
      $scope.org = org;
      $scope.departments = $scope.org.departments;

      $scope.state = {
        isLoadingMore: false,
        loadingError: false,
        canLoadMore: true,
        lastDateFetched: null,
        nextDateToBeFetched: TimeService.getBeginningOfDayFromDate().subtract(14, 'days').startOf('month'),
        rawPermissions: null,
        q: {
          canSendMessage: function() {
            if ($scope.state.rawPermissions) {
              return ('organization_messages.create' in $scope.state.rawPermissions) ? $scope.state.rawPermissions['organization_messages.create'] : false;
            } else {
              return false;
            }
          }
        }
      };

      var permissionsToLookUp = [
        'organization_messages.create'
      ];

      UserPermissionsService.getCanDict(permissionsToLookUp, $scope.org.id)
        .then(function(dikt) {
          $scope.state.rawPermissions = dikt;
        });

      $scope.positions = _.map(allPositions, function(pos) {
        if (_.isNull(pos.department_id)) {
          pos.department = {
            name: 'Uncategorized'
          };
        } else {
          var dept = _.find($scope.departments, {id: pos.department_id});
          if (!_.isUndefined(dept)) {
            pos.department = dept;
          }
        }

        return pos;
      });

      $scope.currentOrgMessages = currentOrgMessages;
      $scope.selectedOrgMessages = $scope.currentOrgMessages;

      $scope.expiredOrgMessages = [];

      $scope.goToProfile = function(emp_id) {
        $location.path('profile/' + emp_id);
      };

      $scope.goToMessage = function(message) {
        $location.path('storeAnnouncements/' + message.id);
      };

      $scope.goToCreate = function() {
        $state.go('storeAnnouncements.new');
      };


      $scope.getNextInterval = function() {
        $scope.state.isLoadingMore = true;
        $scope.state.loadingError = false;
        OrganizationMessages.getOrganizationMessagesSince($scope.org.id, $scope.state.nextDateToBeFetched.format())
            .then(function(oldMessages) {

              _.each(oldMessages, function(msg) {
                if (_.all($scope.currentOrgMessages, function(om) { return om.id !== msg.id}) &&
                    _.all($scope.expiredOrgMessages, function(om) { return om.id !== msg.id})) {
                  $scope.expiredOrgMessages.push(msg);
                }
              });
              $scope.expiredOrgMessages = _.sortBy($scope.expiredOrgMessages, function(m) {
                return -1 * m._created_at_unix;
              });

              $scope.state.isLoadingMore = false;
              $scope.state.lastDateFetched = moment($scope.state.nextDateToBeFetched);
              var dt = moment($scope.state.lastDateFetched).subtract(1, 'month');
              if (dt.isBefore($scope.org.created_at)) {
                dt = moment($scope.org.created_at).startOf('day');
                $scope.state.canLoadMore = false;
              }
              $scope.state.nextDateToBeFetched = dt;
            }, function() {
              $scope.state.loadingError = true;
              $scope.state.isLoadingMore = false;
              console.log('Need to try that again');
            });

      };

    });
